import { render, staticRenderFns } from "./ScBoard.vue?vue&type=template&id=6283a5b0&scoped=true&"
import script from "./ScBoard.vue?vue&type=script&lang=js&"
export * from "./ScBoard.vue?vue&type=script&lang=js&"
import style0 from "./ScBoard.vue?vue&type=style&index=0&id=6283a5b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6283a5b0",
  null
  
)

export default component.exports